// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__31ksa","dragIcon":"SortableItem_dragIcon__3UPtb","disabled":"SortableItem_disabled__3O9IG"};